/* Private per-device field notes, keyed by site id. */
const KEY = "aetheria-notes";
const listeners = new Set();

function read() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "{}");
    return v && typeof v === "object" ? v : {};
  } catch {
    return {};
  }
}

export const getNotes = () => read();
export const getNote = (siteId) => read()[siteId] || "";

export function setNote(siteId, text) {
  const all = read();
  if (text.trim()) all[siteId] = text;
  else delete all[siteId];
  localStorage.setItem(KEY, JSON.stringify(all));
  listeners.forEach((fn) => fn(all));
}

export function onNotesChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/* Formatted plain-text export of every note on this device. */
export function exportNotes(sites) {
  const all = read();
  const ids = Object.keys(all);
  if (!ids.length) return null;
  const rule = "─".repeat(64);
  const date = new Date().toISOString().slice(0, 10);
  const blocks = sites
    .filter((s) => all[s.id])
    .map(
      (s) =>
        `${s.name.toUpperCase()}\n${s.location} · ${s.lat.toFixed(2)}°, ${s.lng.toFixed(2)}°\n${rule}\n${all[s.id].trim()}\n`
    );
  const text = [
    "AETHERIA · CHRONO-ATLAS — FIELD NOTES",
    `Exported ${date} · ${blocks.length} site${blocks.length === 1 ? "" : "s"}`,
    "═".repeat(64),
    "",
    ...blocks.map((b) => b + "\n"),
    "Alternative readings are presented as claims, not fact. Notes are private to the device they were written on.",
    "",
  ].join("\n");
  const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `aetheria-field-notes-${date}.txt`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return blocks.length;
}
